import { render, staticRenderFns } from "./DamoCard.vue?vue&type=template&id=3a008bd6&scoped=true&lang=pug"
import script from "./DamoCard.vue?vue&type=script&lang=js"
export * from "./DamoCard.vue?vue&type=script&lang=js"
import style0 from "./DamoCard.vue?vue&type=style&index=0&id=3a008bd6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a008bd6",
  null
  
)

export default component.exports